// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"CheckboxGroup_checkboxGroup__kOi1K"};